/**
 * Color palette configuration and deterministic hashing for Application pills.
 * Ensures consistent and distinct colors for each unique application across the app.
 */

export interface AppColorPalette {
  bg: string;
  text: string;
  border: string;
}

const APP_COLOR_PALETTES: AppColorPalette[] = [
  {
    bg: "bg-teal-50",
    text: "text-teal-800",
    border: "border-teal-300",
  },
  {
    bg: "bg-indigo-50",
    text: "text-indigo-800",
    border: "border-indigo-300",
  },
  {
    bg: "bg-amber-50",
    text: "text-amber-800",
    border: "border-amber-300",
  },
  {
    bg: "bg-rose-50",
    text: "text-rose-800",
    border: "border-rose-300",
  },
  {
    bg: "bg-emerald-50",
    text: "text-emerald-800",
    border: "border-emerald-300",
  },
  {
    bg: "bg-purple-50",
    text: "text-purple-800",
    border: "border-purple-300",
  },
  {
    bg: "bg-sky-50",
    text: "text-sky-800",
    border: "border-sky-300",
  },
  {
    bg: "bg-orange-50",
    text: "text-orange-800",
    border: "border-orange-300",
  },
  {
    bg: "bg-cyan-50",
    text: "text-cyan-800",
    border: "border-cyan-300",
  },
  {
    bg: "bg-fuchsia-50",
    text: "text-fuchsia-800",
    border: "border-fuchsia-300",
  },
];

/**
 * Returns deterministic Tailwind color classes for any application name.
 */
export function getAppPillClasses(appName: string): string {
  if (!appName) {
    return "bg-slate-100 text-slate-700 border-slate-200";
  }

  // DJB2 hash algorithm for deterministic distribution
  let hash = 5381;
  const normalized = appName.trim().toLowerCase();
  for (let i = 0; i < normalized.length; i++) {
    hash = (hash * 33) ^ normalized.charCodeAt(i);
  }

  const index = Math.abs(hash) % APP_COLOR_PALETTES.length;
  const palette = APP_COLOR_PALETTES[index]!;
  return `${palette.bg} ${palette.text} ${palette.border}`;
}
